enum PanelActionType {
    OPEN_PANEL = "OPEN_PANEL",
    CLOSE_PANEL = "CLOSE_PANEL",
    DISPLAY_ERROR_IN_PANEL = "DISPLAY_ERROR_IN_PANEL",
    SHOW_SPINNER_IN_PANEL = "SHOW_SPINNER_IN_PANEL",
    HIDE_SPINNER_IN_PANEL = "HIDE_SPINNER_IN_PANEL",
    CHANGE_PANEL_SIZE = "CHANGE_PANEL_SIZE",
}

export default PanelActionType;